export default __webpack_public_path__ + "static/media/dashboard-logo.cbede04c.svg";